import { jsx as _jsx } from "react/jsx-runtime";
import AppMenu from './AppMenu';
const AppSidebar = () => {
    return _jsx(AppMenu, {});
};
export default AppSidebar;
